"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = setDictateInterims;
exports.SET_DICTATE_INTERIMS = void 0;
var SET_DICTATE_INTERIMS = 'WEB_CHAT/SET_DICTATE_INTERIMS';
exports.SET_DICTATE_INTERIMS = SET_DICTATE_INTERIMS;

function setDictateInterims(dictateInterims) {
  return {
    type: SET_DICTATE_INTERIMS,
    payload: {
      dictateInterims: dictateInterims
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NldERpY3RhdGVJbnRlcmltcy5qcyJdLCJuYW1lcyI6WyJTRVRfRElDVEFURV9JTlRFUklNUyIsInNldERpY3RhdGVJbnRlcmltcyIsImRpY3RhdGVJbnRlcmltcyIsInR5cGUiLCJwYXlsb2FkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUEsSUFBTUEsb0JBQW9CLEdBQUcsK0JBQTdCOzs7QUFFZSxTQUFTQyxrQkFBVCxDQUE0QkMsZUFBNUIsRUFBNkM7QUFDMUQsU0FBTztBQUNMQyxJQUFBQSxJQUFJLEVBQUVILG9CQUREO0FBRUxJLElBQUFBLE9BQU8sRUFBRTtBQUFFRixNQUFBQSxlQUFlLEVBQWZBO0FBQUY7QUFGSixHQUFQO0FBSUQiLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBTRVRfRElDVEFURV9JTlRFUklNUyA9ICdXRUJfQ0hBVC9TRVRfRElDVEFURV9JTlRFUklNUyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHNldERpY3RhdGVJbnRlcmltcyhkaWN0YXRlSW50ZXJpbXMpIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBTRVRfRElDVEFURV9JTlRFUklNUyxcbiAgICBwYXlsb2FkOiB7IGRpY3RhdGVJbnRlcmltcyB9XG4gIH07XG59XG5cbmV4cG9ydCB7IFNFVF9ESUNUQVRFX0lOVEVSSU1TIH07XG4iXX0=